export interface CustomerMatch {
  customer_id: number
  customer_name: string
  order_count: number
}

interface OrderWithCustomer {
  customer_id: number | null
  customer_name: string
}

/**
 * Groups orders by customer_id and returns top matches sorted by order count
 * Skips orders without customer_id
 */
export function groupCustomerMatches(
  orders: OrderWithCustomer[],
  limit = 3
): CustomerMatch[] {
  const customerMap = orders.reduce((acc, order) => {
    const id = order.customer_id
    if (!id) return acc
    if (!acc[id]) {
      acc[id] = { customer_id: id, customer_name: order.customer_name, order_count: 0 }
    }
    acc[id].order_count++
    return acc
  }, {} as Record<number, CustomerMatch>)

  return Object.values(customerMap)
    .sort((a, b) => b.order_count - a.order_count)
    .slice(0, limit)
}
